/**
 * lib/reading-time-format.ts
 *
 * Pure display-formatting helper for reading-time values.
 * No Node.js imports — safe to use in Client Components.
 *
 * Kept separate from reading-time.ts (which uses `fs`) so that
 * client-side bundles are not incorrectly exposed to Node APIs.
 */

/**
 * Format a reading-time integer for display.
 * Cap: values above 15 render as "15+" to avoid discouraging long-form readers.
 * Values 1–15 render as the exact number.
 *
 * Usage: `{formatReadingTime(n)} min read`
 */
export function formatReadingTime(minutes: number): string {
  return minutes > 15 ? '15+' : String(minutes);
}
